import { componentProvider } from 'js-component-framework';
import getFormattedClassnames from 'utils/getFormattedClassnames';
import NavBar from './nav-bar';
import './nav-bar.scss';
import './primary-menu.scss';

const navBarClassnames = sciencenewsClassnames['nav-bar'];
const navBarSelectors = getFormattedClassnames(navBarClassnames);
const { toggle, navBar, actions } = navBarSelectors;

const navBarConfig = {
  name: 'nav-bar',
  component: NavBar,
  querySelector: { toggle, navBar, actions },
  querySelectorAll: {},
  options: {
    menuStylesheet: 'primary-menu',
  },
};

componentProvider(navBarConfig);
export default navBarConfig;
